/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter, Routes, Route } from 'react-router-dom' //Router components

// Import Components
import ScrollToTop from './components/common/ScrollToTop'
import NotFound from './components/common/NotFound'
import Layout from './components/common/Layout'
import FAQ from './components/homepage/FAQ'
import Home from './components/homepage/Home'
import Demo from './components/demo/Demo.js'
import TestDashboard from './components/demo/TestDashboard.js'
import AllAuth from './components/auth/AllAuth'
import TermsOfService from './components/auth/TermsOfService'
import PrivacyPolicy from './components/auth/PrivacyPolicy'
import ResetPassword from './components/auth/ResetPassword'
import CreateAccount from './components/onboarding/CreateAccount.js'
import Dashboard from './components/user/Dashboard.js'
import Onboarding from './components/onboarding/Onboarding.js'
import Settings from './components/user/Settings.js'
import MediaItem from './components/user/media/MediaItem.js'
import ViewFeedback from './components/reviewing/ViewFeedback.js'
import GiveFeedback from './components/reviewing/GiveFeedback.js'
import FriendReview from './components/reviewing/FriendReview.js'
import ReviewerProfile from './components/reviewing/ReviewerProfile.js'
import RequestFeedback from './components/requestFeedback/RequestFeedback.js'

import { permittedCountryCodes, aiReviewRate } from './helpers/variableDefaults'

//MUI
import getDesignTokens from './helpers/theme.js' //MUI theming presets
import { createTheme, ThemeProvider } from '@mui/material/styles' //MUI theme creator functions/components
import Box from '@mui/material/Box'

// Stripe
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { isInstagramOrFacebook } from './helpers/globalHelpers.js'
import { runGTAGScript } from './helpers/analytics.js'
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)


const App = () => {
  // Helmet Context
  const helmetContext = {}

  // // Geolocation
  // const [countryCode, setCountryCode] = useState('')
  // const getData = async () => {
  //   axios.get('https://ipapi.co/json/').then((response) => {
  //     // const data = response.data
  //     // console.log('countryCode ->', response.data.country_code)
  //     setCountryCode(
  //       response.hasOwnProperty('data') && 
  //       response.data.hasOwnProperty('country_code') && 
  //       response.data.country_code.length === 2 
  //         ? 
  //         response.data.country_code 
  //         : 
  //         ''
  //     )
  //   }).catch((error) => {
  //     console.log(error)
  //   })
  // }

  // useEffect(() => {
  //   //passing getData method to the lifecycle method
  //   getData()
  // }, [])

  // Stripe Options
  const [stripePaymentForm, setStripePaymentForm] = useState({
    amount: aiReviewRate > 0 ? aiReviewRate * 100 : 1000,
    currency: 'usd',
    mode: 'payment',
  })

  return (
    // HelmetProvider must go around everything in order to use dynamic helmets
    <HelmetProvider context={helmetContext}>
      
      {/* Wrap everything in the theme so that these presets cascade down */}
      <ThemeProvider theme={createTheme(getDesignTokens())}>

        {/* The 'wrapper-box' id is referenced in main.scss for global variables that cascade down */}
        <Box id='wrapper-box' bgcolor='background.default' color='text.primary'>
          
          {/* All the routes must be set inside the Browser Router */}
          <BrowserRouter>

            {/* Scroll to top automatically every time route changes */}
            <ScrollToTop />

            {/* Stripe Elements */}
            <Elements options={stripePaymentForm} stripe={stripePromise}>
                
              {/* The Website */}
              <Routes>

                {/* No Navbar Routes — none at the moment, but it could change */}

                {/* Navbar In "Layout"; Navbar only appears for routes that are children of this Route */}
                <Route element={<Layout />}> 

                  {/* Homepage */}
                  <Route path="/" element={<Home />} />

                  {/* Demo */}
                  <Route path="/demo" element={<Demo fromHomepage={false} />} />
                  <Route path="/demo/:testUserFirstName/dashboard" element={<TestDashboard isDemo={true} />} />
                  <Route path="/demo/:testUserFirstName/:profileType/profile-overview" element={<TestDashboard isDemo={true} />} />
                  <Route path="/demo/:testUserFirstName/:profileType/edit-profile" element={<TestDashboard isDemo={true} />} />
                  <Route path="/demo/:testUserFirstName/:profileType/:reviewerFirstName/view-feedback" element={<TestDashboard isDemo={true} />} />
                  <Route path="/demo/:testUserFirstName/:profileType/:reviewerFirstName/reviewer-profile" element={<TestDashboard isDemo={true} />} />
                  <Route path="/demo/:testUserFirstName/:profileType/request-feedback" element={<TestDashboard isDemo={true} />} />


                  {/* FAQ route */}
                  {/* <Route path="/faq" element={<FAQ fromComponent='faq' />} /> */}

                  {/* Auth routes */}
                  <Route path="/login" element={<AllAuth fromCreateAccount={false} />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/reset-password/:userId/:token" element={<ResetPassword />} />
                  <Route path="/tos" element={<TermsOfService />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />

                  {/* Create Account */}
                  <Route path="/create-account" element={<CreateAccount />}/>

                  {/* User */}
                  <Route path="/dashboard/:userId" element={<Dashboard isDemo={false}/>} />
                  <Route path="/settings/:userId" element={<Settings />} />
                  {/* <Route path="/onboarding/:userId" element={<Onboarding />} /> */}

                  {/* Media */}
                  <Route path="/media-item/:mediaItemId/:userId" element={<MediaItem />} />

                  {/* Profile */}
                  <Route path="/dating-profile/:datingProfileId/:userId/request-feedback" element={<RequestFeedback isDemo={false} stripePaymentForm={stripePaymentForm} setStripePaymentForm={setStripePaymentForm} />} />
                  <Route path="/dating-profile/:datingProfileId/:userId/:reviewerUserId/:profileReviewId/view-feedback" element={<ViewFeedback isDemo={false} />} />
                  <Route path="/dating-profile/:datingProfileId/:userId/:reviewerUserId/:profileReviewId/view-past-review" element={<ViewFeedback />} />
                  <Route path="/dating-profile/:datingProfileId/:reviewerUserId/:profileReviewId/give-feedback" element={<GiveFeedback isFriendReview={false} friendProfileReview={{}} />} />
                  <Route path="/dating-profile/:datingProfileId/:profileReviewId/friend-review" element={<FriendReview />} />
                  <Route path="/reviewer-profile/:reviewerProfileId" element={<ReviewerProfile isDemo={false} />} />

                  {/* Not Found; this path matches any path specified, so it needs to come last */}
                  <Route path="*" element={<NotFound />} />

                </Route>

              </Routes>

            </Elements>
                
          </BrowserRouter>
        </Box>
      </ThemeProvider>
    </HelmetProvider>
  )
}

export default App
